// extracted by mini-css-extract-plugin
module.exports = {"label":"ShippingAddressView_label_1GIEk"};